module.exports = __webpack_public_path__ + "static/layer2Finance-c53ce483c4b4d057910c10d6ad55f3e9.png";